// extracted by mini-css-extract-plugin
export default {"MostR":"MostRecentNews_MostR__3h6gH","title":"MostRecentNews_title__7s+bd","col":"MostRecentNews_col__Waa0d","nonFirst":"MostRecentNews_nonFirst__MGNCQ"};